import { IPartnerData } from 'legacy/lut/features/partner360/configuration/models/IPartnerData'

import { IEspAccountInfo } from '../model/types'

type TEspAccountInfoSource = Pick<
  IPartnerData,
  'partnerId' | 'partnerName' | 'country' | 'amplifyTrack' | 'partnerType'
>

/**
 * Builds the read-only Section 1 snapshot from the partner record already loaded on a
 * P360 page. The partner record has no classification/segment fields, so the pilot
 * stands in amplifyTrack and partnerType — flagged in the README and on the demo.
 */
export const getEspAccountInfo = (partnerData: TEspAccountInfoSource): IEspAccountInfo => ({
  partnerId: partnerData.partnerId,
  partnerName: partnerData.partnerName,
  partnerCountry: partnerData.country,
  accountClassification: partnerData.amplifyTrack || 'N/A',
  accountSegment: partnerData.partnerType || 'N/A',
})
